import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren, ReactNode, useRef } from 'react';

import { LoginLayout } from '@gem/components';
import { PopupManager } from '@gem/popups';
import { PortalContainerContextProvider } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import Entities from 'STORE';

interface IUnauthorizedLayoutProps {
  footer?: ReactNode;
  mainWrapperClassName?: string;
}

export const UnauthorizedLayout: FC<PropsWithChildren<IUnauthorizedLayoutProps>> = observer(
  (props) => {
    const { mainBackgroundLight, mainBackgroundDark } = PROJECT_CONFIG.imageAssets;
    const portalContainerRef = useRef<HTMLDivElement>(null);

    return (
      <LoginLayout
        mainWrapperClassName={props.mainWrapperClassName}
        isDarkMode={Entities.appearance.isDark}
        backgroundSrc={{
          light: getMascotImageSrc(mainBackgroundLight),
          dark: getMascotImageSrc(mainBackgroundDark),
        }}
        footer={props.footer}
      >
        <PortalContainerContextProvider value={{ portalContainerRef }}>
          {props.children}
        </PortalContainerContextProvider>
        <PopupManager />
        <div ref={portalContainerRef} />
      </LoginLayout>
    );
  }
);
